module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="member-detail-container '+
((__t=( party ))==null?'':_.escape(__t))+
'">\n  <div class="row">\n    <div class="col-12 col-lg-7">\n      <div class="row member-top-box bg-light">\n        <div class="col-4 col-md-3 col-lg-4 contact">\n          <div class="text-center">\n            <img class="member-detail-photo" src="'+
((__t=( require('../../../../images/mugs/' + id + '.jpg') ))==null?'':__t)+
'" alt="'+
((__t=( full_name ))==null?'':_.escape(__t))+
'" width="100%" />\n            ';
 if (address_phone) { 
__p+='\n              <a href="tel:'+
((__t=( address_phone ))==null?'':_.escape(__t))+
'">'+
((__t=( address_phone.substring(0,3) + '-' + address_phone.substring(3,6) + '-' + address_phone.substring(6,11) ))==null?'':_.escape(__t))+
'</a><br>\n            ';
 } 
__p+='\n\n            ';
 if (address_email) { 
__p+='\n              <a href="mailto:'+
((__t=( address_email ))==null?'':_.escape(__t))+
'">Email member</a>\n            ';
 } 
__p+='\n          </div>\n        </div>\n        <div class="col-8 col-md-9 col-lg-8 member-top-info">\n          <h1 class="blue-heading">'+
((__t=( full_name ))==null?'':_.escape(__t))+
'</h1>\n          ';
 if (vacant === 'vacant') { 
__p+='\n            <h4 class="blue-heading">'+
((__t=( name_last ))==null?'':__t)+
' formerly represented '+
((__t=( district_type ))==null?'':__t)+
' District '+
((__t=( district_number ))==null?'':__t)+
'</h4>\n          ';
 } else { 
__p+='\n            <h4 class="blue-heading">'+
((__t=( party ))==null?'':_.escape(__t))+
', '+
((__t=( district_type ))==null?'':_.escape(__t))+
' District '+
((__t=( district_number ))==null?'':_.escape(__t))+
'</h4>\n          ';
 } 
__p+='\n          <hr class="unindent">\n          <div class="about-member">\n            ';
 if (title && vacant === "current") { 
__p+='\n              <p><strong>Leadership role:</strong> '+
((__t=( title ))==null?'':_.escape(__t))+
'</p>\n            ';
 } 
__p+='\n\n            ';
 if (occupation) { 
__p+='\n              <p><strong>Occupation:</strong> '+
((__t=( occupation ))==null?'':_.escape(__t))+
'</p>\n            ';
 } 
__p+='\n\n            ';
 if (district_address_city) { 
__p+='\n              <p><strong>Home town:</strong> '+
((__t=( district_address_city ))==null?'':_.escape(__t))+
'</p>\n            ';
 } 
__p+='\n\n            ';
 if (education) { 
__p+='\n               <p><strong>Education:</strong> '+
((__t=( education ))==null?'':_.escape(__t))+
'</p>\n            ';
 } 
__p+='\n\n            ';
 if (religion) { 
__p+='\n               <p><strong>Religion:</strong> '+
((__t=( religion ))==null?'':_.escape(__t))+
'</p>\n            ';
 } 
__p+='\n          </div> <!-- /.about-member -->\n        </div> <!-- /.member-top-info -->\n      </div> <!-- /.member-top-box -->\n    </div> <!-- /.col-lg-7 -->\n    <!--<div class="col-12 col-lg-4" id="batting-average">\n      ';
 if (batting_average) { 
__p+='\n        <h4 class="blue-heading">Legislative Batting Average: <span id="bat-avg">.'+
((__t=( batting_average ))==null?'':__t)+
'</span> <svg class="info-tip tipped" height="16" width="16" viewBox="0 0 512 512"><title>Batting averages show the ratio of bills passed out of the general assymbly to bills introduced by a member in previous sessions. The calculation excludes resolutions and bills introduced during special sessions.</title><path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/></svg>\n        </h4>\n        <p>Batting averages show the ratio of bills passed out of the general assembly to bills introduced by a member in previous sessions. The calculation excludes resolutions and bills introduced during special sessions.</p>\n        <p>(Proportion of the '+
((__t=( bill_count ))==null?'':__t)+
' bills '+
((__t=( full_name ))==null?'':__t)+
' authored in previous sessions that were passed by the legislature.)</p>\n      ';
 } else { 
__p+='\n        <p>'+
((__t=( full_name ))==null?'':__t)+
' is a Freshman legislator.</p>\n      ';
 } 
__p+='\n    </div>--> <!-- /#batting-average -->\n    <!-- this is a long block of formatted text - may scrape it one day but it\'s not actually in our API currently -->\n    <!-- <div class="col-12">\n      ';
 if (bio) { 
__p+='\n        <div class="bio">\n            '+
((__t=( bio ))==null?'':_.escape(__t))+
'\n        </div>\n      ';
 } 
__p+='\n    </div> -->\n\n    <div class="col-12 col-lg-4">\n      <div class="row">\n        ';
if(district) { 
__p+='\n          <div class="col-12">\n            <div class="row district-info">\n              <div class="col-md-12">\n                <h4 class="blue-heading">District characteristics</h4>\n              </div>\n              <table class="table table-sm">\n                <tr>\n                  <td>Population</td>\n                  <td>'+
((__t=( district.get("total_population").toLocaleString() ))==null?'':__t)+
'</td>\n                </tr>\n                <tr>\n                  <td>Median income</td>\n                  <td>$'+
((__t=( district.get("median_household_income").toLocaleString() ))==null?'':__t)+
'</td>\n                </tr>\n                <tr>\n                  <td>Median age</td>\n                  <td>'+
((__t=( district.get("median_age") ))==null?'':__t)+
' years</td>\n                </tr>\n                <tr>\n                  <td>Percent with a college degree</td>\n                  <td>'+
((__t=( district.get("pct_college_grad") ))==null?'':__t)+
'%</td>\n                </tr>\n                <tr>\n                  <td>Percent Georgia natives</td>\n                  <td>'+
((__t=( district.get("pct_georgia_born") ))==null?'':__t)+
'%</td>\n                </tr>\n                <tr>\n                  <td>White</td>\n                  <td>'+
((__t=( district.get("white") ))==null?'':__t)+
'%</td>\n                </tr>\n                <tr>\n                  <td>Black</td>\n                  <td>'+
((__t=( district.get("black") ))==null?'':__t)+
'%</td>\n                </tr>\n                <tr>\n                  <td>Hispanic</td>\n                  <td>'+
((__t=( district.get("hispanic") ))==null?'':__t)+
'%</td>\n                </tr>\n                <tr>\n                  <td>Asian</td>\n                  <td>'+
((__t=( district.get("asian") ))==null?'':__t)+
'%</td>\n                </tr>\n                <tr>\n                  <td>Multi-race</td>\n                  <td>'+
((__t=( district.get("multi") ))==null?'':__t)+
'%</td>\n                </tr>\n                <tr>\n                  <td>Other race</td>\n                  <td>'+
((__t=( district.get("other") ))==null?'':__t)+
'%</td>\n                </tr>\n              </table>\n            </div> <!-- .row.district-info -->\n            <div class="col-md-12 small">\n              <strong>Source:</strong> U.S. Census Bureau American Community Survey\n            </div>\n          </div> <!-- col-12 -->\n        ';
 } 
__p+='\n      </div> <!-- .row -->\n    </div> <!-- .col-12 col-lg-4 -->\n  </div> <!-- .row -->\n</div> <!-- .member-detail-container -->\n';
}
return __p;
};
